import { CompetencesMatrixTheme, getCompetencesMatrixTheme } from './competencesMatrix/theme';
import { CalendarTheme, getCalendarThemeConfig } from './components/Calendar';
import { DrawerDetailsTheme, getDrawerDetailsThemeConfig } from './components/DrawerDetails';

import { FormStepperTheme, getFormStepperThemeConfig } from './components/FormStepper';
import { getRichTextEditorThemeConfig, RichTextEditorTheme } from './components/RichTextEditor';
import { ExternalReception, getExternalReception } from './externalReception';
import { getOfferDetailsThemeConfig, OfferDetailsTheme } from './offerDetails';
import { getOrderDetailsTheme, OrderDetailsTheme } from './order/theme';
import { getProductDetailsThemeConfig, ProductDetailsTheme } from './productDetails';
import { getProductionOrdersThemeConfig, ProductionOrdersTheme } from './productionOrders';
import { getEditLotsThemeConfig, EditLotsTheme } from './editLots';

export const appTheme = {
  productDetails: getProductDetailsThemeConfig() as ProductDetailsTheme,
  productionOrders: getProductionOrdersThemeConfig() as ProductionOrdersTheme,
  offerDetails: getOfferDetailsThemeConfig() as OfferDetailsTheme,
  drawerDetails: getDrawerDetailsThemeConfig() as DrawerDetailsTheme,
  formStepper: getFormStepperThemeConfig() as FormStepperTheme,
  richTextEditor: getRichTextEditorThemeConfig() as RichTextEditorTheme,
  orderDetails: getOrderDetailsTheme() as OrderDetailsTheme,
  calendar: getCalendarThemeConfig() as CalendarTheme,
  editLots: getEditLotsThemeConfig() as EditLotsTheme,
  externalReception: getExternalReception() as ExternalReception,
  competenceMatrix: getCompetencesMatrixTheme() as CompetencesMatrixTheme,
} as const;
export type AppTheme = typeof appTheme;
